import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import Logo from "../../images/fansfirst-logo-small.svg";
import LogoFr from "../../images/fansfirst-logo-small-fr.svg";
import { withTranslation } from "react-i18next";
import analytics from "../../analytics";

const styles = {
  footerContainer: {
    backgroundColor: "#EAEFF4",
    width: "100%",
    '@media (max-width: 959px)' : {
      minHeight: "288px",
      marginTop: "3rem",
      paddingTop: "30px",
      paddingLeft: "50px",
      paddingRight: "50px",
      paddingBottom: "0px",
    },
    minHeight: "300px",
    marginTop: "3rem",
    paddingTop: "50px",
    paddingLeft: "50px",
    paddingRight: "50px",
    paddingBottom: "0px",
  },
  footerContainerSideNav: {
    backgroundColor: "#EAEFF4",
    width: "100%",
    '@media (max-width: 959px)' : {
      minHeight: "288px",
      paddingTop: "30px",
      paddingLeft: "50px",
      paddingRight: "50px",
      paddingBottom: "0px",
    },
    minHeight: "300px",
    paddingTop: "50px",
    paddingLeft: "50px",
    paddingRight: "50px",
    paddingBottom: "0px",
  },
  footerItem: {
    textAlign: "center",
    paddingBottom: "50px",
    '@media (max-width: 959px)':{
      paddingBottom: "5px"
    }
  },
  footerInner: {
    margin: "0 auto",
    padding: "3.75rem 1rem",
    display: "flex",
    maxWidth: "720px",
  },
  footerInnerMobile: {
    padding: "3.75rem 1rem",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
  },
  footerLeftBox: {
    flex: "1",
    display: "flex",
    padding: "1rem 2rem",
    flexDirection: "column",
  },
  footerLeftInnerBox: {
    height: "48px",
    position: "relative",
    marginBottom: "32px",
  },
  footerLeftInnerImageBox: {
    paddingBottom: "30px",
  },
  footerLeftInnerTextBox: {
    fontSize: "0.875rem",
    color: "rgba(0, 0, 0, 0.54)",
    fontWeight: "400",
    lineHeight: "1.375em",
    margin: "0",
    display: "block",
    overflowWrap: "break-word",
    wordWrap: "break-word",
    hyphens: "auto",
  },
  footerRightBox: {
    flex: "1",
    display: "flex",
    padding: "1rem 2rem",
    flexDirection: "column",
  },
  footerRightInnerBox: {
    marginLeft: "5rem",
    marginBottom: "1rem",
  },
  footerRightInnerTextBox: {
    margin: "0",
    display: "block",
    fontSize: "1rem",
    color: "rgba(0, 0, 0, 0.87)",
    fontWeight: "500",
    lineHeight: "2.5",
  },
  footerTabIndexRightSosmed: {
    border: "0",
    margin: " 0",
    cursor: "pointer",
    display: "inline-flex",
    outline: "none",
    marginRight: "0.5rem",
    position: "relative",
    alignItems: "center",
    userSelect: "none",
    verticalAlign: "middle",
    justifyContent: "center",
    textDecoration: "none",
    backgroundColor: "transparent",
    flex: "0 0 auto",
    width: "35px",
    color: "rgba(0, 0, 0, 0.54)",
    height: "35px",
    padding: "0",
    fontSize: "1.5rem",
    textAlign: "center",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    borderRadius: "50%",
  },
  footerSpanClearSosmed: {
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    display: "block",
    zIndex: "0",
    position: "absolute",
    overflow: "hidden",
    borderRadius: "inherit",
    pointerEvents: "none",
  },
  footerSpanFBLink: {
    width: "100%",
    display: "flex",
    alignItems: "inherit",
    justifyContent: "inherit",
  },
  footerSecondBottom: {
    width: "100%",
    padding: "1rem",
    display: "flex",
    borderTop: "1px solid #D5DEE9",
    alignItems: "center",
    borderBottom: "1px solid #D5DEE9",
    justifyContent: "center",
  },
  linkLegal: {
    border: "0",
    cursor: "pointer",
    display: "inline-flex",
    outline: "none",
    position: "relative",
    alignItems: "center",
    userSelect: "none",
    verticalAlign: "middle",
    justifyContent: "center",
    textDecoration: "none",
    backgroundColor: "transparent",
    color: "rgba(0, 0, 0, 0.87)",
    boxSizing: "border-box",
    transition:
      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    fontWeight: 500,
    lineHeight: "1.4em",
    borderRadius: "4px",
    padding: "7px 8px",
    minWidth: "64px",
    fontSize: "0.8125rem",
    minHeight: "32px",
  },
  spanTermAndConditionOne: {
    width: "100%",
    display: "inherit",
    alignItems: "inherit",
    justifyContent: "inherit",
  },
  spanTermAndConditionTwo: {
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    display: "block",
    zIndex: "0",
    position: "absolute",
    overflow: "hidden",
    borderRadius: "inherit",
    pointerEvents: "none",
  },
  footerFirstBottom: {
    width: "100%",
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #D5DEE9",
    justifyContent: "center",
  },
  footerCopyRight: {
    margin: "0",
    display: "block",
    fontSize: "0.875rem",
    color: "rgba(0, 0, 0, 0.54)",
    fontWeight: "400",
    lineHeight: "1.375em",
    textAlign: "center",
  },
};

const footer = ({ 
  classes, 
  isSideNavPath,
  t,
  i18n,
}) => {
  const currentLang = ((i18n && i18n.language) || "").toLowerCase();
  const logoSrc = currentLang.startsWith("fr") ? LogoFr : Logo;
  return (
    <>
      <Grid 
        container 
        className={isSideNavPath ? classes.footerContainerSideNav : classes.footerContainer}
      >
        <Grid
          item
          md={6}
          xs={12}
          className={classes.footerItem}
        >
          <img
            src={logoSrc}
            className={classes.footerLeftInnerImageBox}
            alt="FansFirst Logo"
          />
          <p className={classes.footerLeftInnerTextBox}>
            {t("footer.tagline.line1")} <br /> {t("footer.tagline.line2")}
          </p>
        </Grid>

        <Grid
          item
          md={6}
          xs={12}
          className={classes.footerItem}
        >
          <Typography variant="body1" style={{ fontWeight: "bold" }}>
            {t("footer.social.title")}
          </Typography>
          <p style={classes.socialIcon}>
            <a
              tabIndex="0"
              className="footerTabIndexRightSosmed"
              role="button"
              href="https://www.facebook.com/fansfirst.ca"
              target="_blank"
              onClick={() => analytics.track("social_link_clicked", { network: "facebook", surface: "footer" })}
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKYSURBVHgBzZiNcdNAEIXfalyAOuBSAXEFiA5MA1iuAKgAUwFQgZQKCBWQVEBSQa4EVeDL7t0p1v+fZdnfjMaWvT493+097YowhcRECPAeBhGf3fIR+kPI+ND2IDzggEfs6AkjocGRiZELf+VfbPlVYRwicu9F6iE/GCYsMXuO/ILjrExF8yzfsbh9XyD1CFIc8QduueZEBH7smr0A7aJiFvX/DKIEZcdOzKYtgDpEJVgCQowt3dU/Rk3Uxi/fcjSIo4oo5Zfv1CQfS8Y5ty7m3Kr0NeEf5hUlniYeplG2mKgSF/pVWh+l5DhL+I550LytYnymx8ZvU/OCJi8Ur9vSD3kbeFHKG+c8omRZ2kR1YdjAnZG/2UWE8W7eNrj4U4ZphKxIjNwLm28J74fecloxnAKQ5E+MGKjCHMhNu4pLk6RyDdUxipIiYcVz9oFVzkV9CQk/Ud+F3XDlEvjS5ZyMtx/WJDmmcH3cXquwUJz/FKdPOYf029kBz7UIqb+CwqYwcAVnjzBiF56e+gHn51gjFRdw9+OeoZt20nlRA2Ky5YUFeDcgSouw0R3MSZhBM6ZX1q0NNpjCAb84R48zTny+pb+lmNSIwRbL8/5SnTWt7E4a3sRVqV4kbYmJMAZu8wK+6T4AhS1/ebQ0yHl1keJakGIRedlzwG8sbxtNaNutIxcmhZ0k7qWRlfP13LHhdbX2stZRRuf1vlDuxA0+4TJLmtmSvEBZmEyjwTcsjcGuWpLXn13sKLWBSyFd+I7uqx83P1Rx4s69rFnbc4t2YYL8C2M7Y435ebJjt4hCpzBB1j2mG296GqeT2bFiWve1ed3CcmQby65xuacxHveo0+CmaAldTLt9SxXq2r4IrvCTI2zMGekrJzTBrxUNwcon5az4AAAAAElFTkSuQmCC"
                alt="FB Icon"
              />
            </a>
            &nbsp;&nbsp;&nbsp;
            <a
              tabIndex="0"
              className="footerTabIndexRightSosmed"
              role="button"
              href="https://www.instagram.com/fansfirst.ca"
              target="_blank"
              onClick={() => analytics.track("social_link_clicked", { network: "instagram", surface: "footer" })}
            >
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOhSURBVHgBvViLedowEP7lMgCdoMoEIRPE3YAsUGCCkAlCJqgzAc4ETSeoM0HpBu4GXqCodycZRLDkV8v/ffp4+CT9vjvdQwpDsDUpElzDIKVfMxpTNxgVjVKGQoE93rBSO/SE6iy5NbzxmmYs6FOjH5jkxpEsu0zoRmxrNiR5j6NWhqIkLb8QuU2boGohpEniG6y5/iWY4OeY9hKESS2J1M//QIqhZe2tmYcEVITUFpeAwhIL9XL+N85IzZ35LocGcuodKe3MN9bJ+6Iin7vxfW5y8ljhB+KkCpJ5BTvvB3SLTXvyJ0N+aijUhMPM1Fnp5kilhg0JjwhB0cIL9Ywx2BqOg18je2xojyf71U7QTlsaMVLHIHvryfpRv0blBoODa06a+06mqlrIsUmvWK4mFjuFJZbqSkhZ/9Poh8oRL50fVcgNKyFtlHZaS9yPmAkz920+gFRBL/VRtMDkEskecH7aDEMnFBxgt2YW3VA5J7c5sgmskUzMrcTBc9gkzrBz69NmnJb2+I0wNBcJE6J2SxPCSA6b6IanGc19EvP4sD7L2lmT2aZu7tRbI36iqXKZHN6iPzIy04MjkjqNVqJhGywfiBSEXF8QJ45juqO4f/LYkZ8dqcxpp16UjEnuwaRZm0p8ZtqwRgyzZCCxQvzGnub7Btm1aNGaOA+sEd0rwZD0czwQ1xGZhfss0R/TBOMQe6kKI5AMWsA483M1GkKtVTOonqv6EPPllpIJVqoADgHYRyYnk8PGaYTvulfJxLp2MP6i00O2sKdvBUswJxukhzCCs4qiM7GJtFgGc/THWuIUh42Vyk+e2GS/CZzYdhCnCaWHX9GW5I/4CKeQEuehhdPQnAgWnk+xzBLNB6N0nxoxUJs3ET/JTRkR1vVbBLKEFiKxtFZDuZhmm+UQSm6Qk5MJTajNvJdIX2I4dlKT2TXDaYrLHtTtm9005JipFHccxbmeso5eoL4GaJ5Xec8L2cz2kZVUymHrlNKtwy+tX8wjTd4gBENJeaUyjEHv0rpGbtoa3FIKRz4w3c06I7t8ci6RRtfmStnhtEsyuGtp37jjydD9KqZetw2VmNrDaa7kioFNdmmw3767xzhP4hwsrYNfBlyvrdTr+7+bqwtL7g4jK4QWVKF7C0aXa6hwvzkcO3nxyDVUNze2oWSJ8QQrOdUuJMTQ56pTg4+7rSo0+qHuxp/POqrRxHxwL2rbvhSWJA//cpjHTvIrJ/cv6g098RdYmknscyXPPAAAAABJRU5ErkJggg=="
                alt="Instagram Icon"
              />
            </a>
            &nbsp;&nbsp;&nbsp;
            <a
              tabIndex="0"
              className="footerTabIndexRightSosmed"
              role="button"
              href="https://www.x.com/FansFirstTix"
              target="_blank"
              onClick={() => analytics.track("social_link_clicked", { network: "x", surface: "footer" })}
            >
              <img
                src="data:image/jpeg;base64,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"
                alt="X Icon"
              />
            </a>
            &nbsp;&nbsp;&nbsp;
          </p>
        </Grid>
      </Grid>
      <div style={{ backgroundColor: "#EAEFF4" }}>
        <div className={classes.footerSecondBottom}>
          <a
            className={classes.linkLegal}
            href="/why-us"
            style={{ margin: "0px 1rem" }}
          >
            <span className={classes.spanTermAndConditionOne}>
              {t("footer.links.about")}
            </span>
            <span className={classes.spanTermAndConditionTwo}></span>
          </a>
          <a
            className={classes.linkLegal}
            href="/legal"
            style={{ margin: "0px 1rem" }}
          >
            <span className={classes.spanTermAndConditionOne}>
              {t("footer.links.terms")}
            </span>
            <span className={classes.spanTermAndConditionTwo}></span>
          </a>
          <a
            className={classes.linkLegal}
            href="/faqs"
            style={{ margin: "0px 1rem" }}
          >
            <span className={classes.spanTermAndConditionOne}>
              {t("footer.links.faqs")}
            </span>
            <span className={classes.spanTermAndConditionTwo}></span>
          </a>
        </div>
        <div className={classes.footerFirstBottom}>
          <span className={classes.footerCopyRight}>
            {t("footer.copyright", { start: 2019, year: new Date().getFullYear() })}
          </span>
        </div>
      </div>
    </>
  );
};

export default withTranslation()(withStyles(styles)(footer));
